import { Schema } from '../create/components/division-form.schema';
import { DivisionForm } from '../create/components/division-form';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useUpdateDivisionMutation } from '../mutations';
import { useDivisionDetailQuery } from '../queries';
import { divisionIdParamSchema } from '~/schemas';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';

export function Page() {
  const { divisionId } = useParams(divisionIdParamSchema.parse);
  const { data } = useDivisionDetailQuery(divisionId);
  const mutation = useUpdateDivisionMutation();
  const navigate = useNavigate();

  async function onSubmit(payload: Schema) {
    if (data) {
      await toast.promise(
        mutation.mutateAsync({ id: divisionId, payload: { ...payload, series: Number(data.series.id) } }),
        {
          success: 'Divisionen har uppdaterats',
          pending: 'Uppdaterar divisionen...',
        }
      );
      await navigate(-1);
    }
  }

  if (!data) return false;

  return (
    <Fragment>
      <PageLayout.Heading text="Redigera division" />

      <PageLayout.Section>
        <DivisionForm
          onSubmit={onSubmit}
          isLoading={mutation.isPending}
          mode="edit"
          defaultValues={{
            name: data?.name ?? '',
            level: data?.level ?? 0,
            max_teams: data?.max_teams ?? 0,
            results_per_round: data?.results_per_round ?? 0,
            rounds: data.rounds.map(round => round.id) ?? [],
            series: [String(data.series.name), Number(data.series.id)],
          }}
        />
      </PageLayout.Section>
    </Fragment>
  );
}
